import request from '@/utils/request'

// 分页查询解决方案
export function queryPlanByPageApi(data) {
  return request({
    method: 'post',
    url: 'v1/web/plan/queryPlanByPage',
    data
  })
}

// 查询解决方案详情
export function queryByModuleDetailApi(data) {
    return request({
        method: 'post',
        url: 'v1/web/plan/queryPlanDetail',
        data
    })
}

